import "@styles/components/movieInfo.scss";
import { imageResizer } from "@utils/util";
import { selectCropHost } from "@app/global";
import { useSelector } from "react-redux";
import { useState } from "react";

const MovieContent = ({ movie, isPlayerOpen }) => {
  const cropHost = useSelector(selectCropHost);
  const [hasImageError, setHasImageError] = useState(false);

  const width = window.Android ? 500 : 760;
  const height = window.Android ? 155 : 230;
  return (
    <>
      <div
        className={`content ${window.Android && isPlayerOpen ? "hidden" : ""} ${movie.type === "tv_show" ? "tv-show" : ""}`}
      >
        {movie.image_title && !hasImageError ? (
          <img
            src={imageResizer(
              cropHost,
              movie.image_title,
              width,
              height,
              "cover",
              "png"
            )}
            alt={movie.name}
            className="image-title"
            onError={() => setHasImageError(true)}
          />
        ) : (
          <h1 className="title">
            {movie.translations && movie.translations.name
              ? movie.translations.name
              : movie.name}
          </h1>
        )}
        <div className="metadata">
          <span>{movie.year}</span>
          <span>{movie.pg}+</span>
          <span>{`${movie.duration} min`}</span>
          <span>
            {movie.translations && movie.translations.type
              ? movie.translations.type
              : movie.type}
          </span>
        </div>
        {movie.casts.length > 0 && (
          <div className="casts" key={movie.id}>
            {movie.casts.slice(0, 5).map((cast) => (
              <div className="cast" key={cast.id}>
                <p className="cast-name">{cast.name}</p>
              </div>
            ))}
          </div>
        )}
        <p className="description">
          {movie.translations && movie.translations.description
            ? movie.translations.description
            : movie.description}
        </p>
      </div>
    </>
  );
};

export default MovieContent;
